module.exports = __webpack_public_path__ + "static/img/8-3.61dfbd3d.jpg";